<main class="one-login-page">

    <section class="login-hero">

        <div class="login-visual">

            <div class="visual-background"></div>
            <div class="visual-gradient"></div>

            <div class="visual-content">

                <div class="visual-eyebrow">
                    OYUN / YARAT / ÖĞREN / PAYLAŞ
                </div>

                <!-- =====================================================
                     BRAND / LOGO
                     ===================================================== -->

                <div class="visual-brand">

                    <div class="visual-brand-logo">
                        <img
                            src="/logo/logo.png"
                            alt="ANAMETA" />
                    </div>

                    <div class="visual-brand-product">
                        ONE
                    </div>

                </div>

                <p class="visual-description">
                    ANAMETA ONE, yaratıcı insanların oyunlarla,
                    teknolojiyle ve birbirleriyle buluştuğu yepyeni
                    bir dünya. Sen de aramıza katıl.
                </p>

                <div class="visual-line"></div>

                <div class="visual-side-text">
                    <span>DAHA İYİ</span>
                    <span>OYUNLAR İÇİN</span>
                    <span>DAHA FAZLA</span>
                    <span>İNSAN</span>
                </div>

            </div>

            <div class="visual-bottom-text">
                <span>Daha</span>
                <strong>Büyük Dünyalar</strong>
                <span>Birlikte Mümkün</span>
                <i></i>
            </div>

        </div>

        <div class="login-panel">

            <div class="login-card">

                <div class="login-card-header">

                    <div class="login-eyebrow">
                        ANAMETA ONE'A HOŞ GELDİNİZ
                    </div>

                    <h2>
                        Giriş Yap
                    </h2>

                    <p>
                        Hesabınıza giriş yaparak oyunların, varlıkların,
                        eğitimlerin ve topluluğun bir parçası olun.
                    </p>

                </div>

                <form
                    class="login-form"
                    [formGroup]="loginForm"
                    (ngSubmit)="Login()"
                    novalidate>

                    <div
                        class="login-error"
                        *ngIf="errorMessage"
                        role="alert"
                        aria-live="assertive">

                        <div class="login-error-icon">

                            <svg viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="9"></circle>
                                <path d="M12 7v6"></path>
                                <path d="M12 17h.01"></path>
                            </svg>

                        </div>

                        <div class="login-error-content">

                            <strong>
                                {{ errorTitle || 'Hata' }}
                            </strong>

                            <span>
                                {{ errorMessage }}
                            </span>

                        </div>

                        <button
                            type="button"
                            class="login-error-close"
                            aria-label="Hata mesajını kapat"
                            (click)="clearError()">

                            ×

                        </button>

                    </div>

                    <div
                        class="form-field"
                        [class.is-invalid]="
                            loginForm.controls.email.invalid &&
                            loginForm.controls.email.touched
                        ">

                        <div class="field-icon">

                            <svg viewBox="0 0 24 24">
                                <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5v-11Z"></path>
                                <path d="m4 7 8 6 8-6"></path>
                            </svg>

                        </div>

                        <div class="field-content">

                            <label for="email">
                                E-posta adresi
                            </label>

                            <input
                                id="email"
                                type="email"
                                formControlName="email"
                                autocomplete="email"
                                placeholder="ornek@eposta.com"
                                (input)="clearError()" />

                        </div>

                    </div>

                    <div
                        class="field-validation-error"
                        *ngIf="
                            loginForm.controls.email.touched &&
                            loginForm.controls.email.hasError('required')
                        ">

                        E-posta adresi zorunludur.

                    </div>

                    <div
                        class="field-validation-error"
                        *ngIf="
                            loginForm.controls.email.touched &&
                            !loginForm.controls.email.hasError('required') &&
                            loginForm.controls.email.hasError('email')
                        ">

                        Geçerli bir e-posta adresi girin.

                    </div>

                    <div
                        class="form-field"
                        [class.is-invalid]="
                            loginForm.controls.password.invalid &&
                            loginForm.controls.password.touched
                        ">

                        <div class="field-icon">

                            <svg viewBox="0 0 24 24">
                                <rect
                                    x="4"
                                    y="10"
                                    width="16"
                                    height="10"
                                    rx="2">
                                </rect>

                                <path d="M8 10V7a4 4 0 0 1 8 0v3"></path>
                            </svg>

                        </div>

                        <div class="field-content">

                            <label for="password">
                                Şifre
                            </label>

                            <input
                                id="password"
                                formControlName="password"
                                [type]="ShowPassword ? 'text' : 'password'"
                                autocomplete="current-password"
                                placeholder="••••••••"
                                (input)="clearError()" />

                        </div>

                        <button
                            type="button"
                            class="password-toggle"
                            aria-label="Şifreyi göster veya gizle"
                            (click)="TogglePassword()">

                            <svg
                                *ngIf="!ShowPassword"
                                viewBox="0 0 24 24">

                                <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"></path>

                                <circle
                                    cx="12"
                                    cy="12"
                                    r="2.5">
                                </circle>

                            </svg>

                            <svg
                                *ngIf="ShowPassword"
                                viewBox="0 0 24 24">

                                <path d="m3 3 18 18"></path>
                                <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8"></path>
                                <path d="M9.8 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-2.4 3.2"></path>
                                <path d="M6.2 6.2C3.5 8 2 12 2 12s3.5 7 10 7a9.8 9.8 0 0 0 3.1-.5"></path>

                            </svg>

                        </button>

                    </div>

                    <div
                        class="field-validation-error"
                        *ngIf="
                            loginForm.controls.password.touched &&
                            loginForm.controls.password.hasError('required')
                        ">

                        Şifre zorunludur.

                    </div>

                    <div class="login-options">

                        <label class="remember-control">

                            <input type="checkbox" />

                            <span class="custom-checkbox">

                                <svg viewBox="0 0 24 24">
                                    <path d="m5 12 4 4L19 6"></path>
                                </svg>

                            </span>

                            <span>
                                Beni hatırla
                            </span>

                        </label>

                        <a
                            class="forgot-password"
                            href="/forgot-password">

                            Şifremi unuttum?

                        </a>

                    </div>

                    <div
                        class="recaptcha-wrapper"
                        *ngIf="isRecaptchaEnabled">

                        <div #recaptchaContainer></div>

                    </div>

                    <button
                        type="submit"
                        class="login-button"
                        [disabled]="isSubmitting">

                        <ng-container *ngIf="!isSubmitting">

                            <span>
                                Giriş Yap
                            </span>

                            <svg viewBox="0 0 24 24">
                                <path d="M5 12h14"></path>
                                <path d="m14 7 5 5-5 5"></path>
                            </svg>

                        </ng-container>

                        <ng-container *ngIf="isSubmitting">

                            <span class="login-button-loader"></span>

                            <span>
                                Giriş yapılıyor...
                            </span>

                        </ng-container>

                    </button>

                    <div class="login-divider">

                        <span></span>

                        <small>
                            veya
                        </small>

                        <span></span>

                    </div>

                    <button
                        type="button"
                        class="social-button">

                        <span class="google-icon">
                            <span>G</span>
                        </span>

                        <strong>
                            Google ile devam et
                        </strong>

                    </button>

                    <button
                        type="button"
                        class="social-button">

                        <svg
                            class="apple-icon"
                            viewBox="0 0 24 24">

                            <path d="M17.1 12.5c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-2-0.9-3.3-0.9-1.7 0-3.3 1-4.2 2.5-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.3 2.5 1.3-.1 1.8-.8 3.4-.8 1.6 0 2 .8 3.4.8 1.4 0 2.3-1.2 3.2-2.5 1-1.4 1.4-2.9 1.4-3-.1 0-3.4-1.3-3.4-4.1Z"></path>
                            <path d="M14.7 5.3c.7-.9 1.2-2.1 1.1-3.3-1.1 0-2.4.7-3.2 1.6-.7.8-1.3 2-1.1 3.2 1.2.1 2.4-.6 3.2-1.5Z"></path>

                        </svg>

                        <strong>
                            Apple ile devam et
                        </strong>

                    </button>

                    <button
                        type="button"
                        class="social-button">

                        <span
                            class="microsoft-icon"
                            aria-hidden="true">

                            <span class="ms-red"></span>
                            <span class="ms-green"></span>
                            <span class="ms-blue"></span>
                            <span class="ms-yellow"></span>

                        </span>

                        <strong>
                            Microsoft ile devam et
                        </strong>

                    </button>

                    <div class="register-text">

                        Hesabın yok mu?

                        <a href="/register">
                            Üye Ol
                        </a>

                    </div>

                </form>


            </div>

        </div>

    </section>

    <section class="login-features">

        <div class="feature-item">

            <div class="feature-icon">

                <svg viewBox="0 0 24 24">
                    <circle cx="9" cy="8" r="3"></circle>
                    <circle cx="17" cy="9" r="2.5"></circle>
                    <path d="M3 20v-2a6 6 0 0 1 12 0v2"></path>
                    <path d="M15 14.5a5 5 0 0 1 6 4.9V20"></path>
                </svg>

            </div>

            <div>

                <strong>
                    Yaratıcı Topluluk
                </strong>

                <span>
                    Aynı tutkuyu paylaşan insanlarla tanışın
                </span>

            </div>

        </div>

        <div class="feature-item">

            <div class="feature-icon">

                <svg viewBox="0 0 24 24">
                    <path d="m12 2 9 5-9 5-9-5 9-5Z"></path>
                    <path d="m3 7 9 5 9-5v10l-9 5-9-5V7Z"></path>
                    <path d="M12 12v10"></path>
                </svg>

            </div>

            <div>

                <strong>
                    Sınırsız İçerik
                </strong>

                <span>
                    Oyunlar, 3D varlıklar, uygulamalar ve daha fazlası
                </span>

            </div>

        </div>

        <div class="feature-item">

            <div class="feature-icon">

                <svg viewBox="0 0 24 24">
                    <path d="m2 9 10-5 10 5-10 5L2 9Z"></path>
                    <path d="M6 11v5c3 3 9 3 12 0v-5"></path>
                </svg>

            </div>

            <div>

                <strong>
                    Sürekli Öğrenim
                </strong>

                <span>
                    Uzmanlardan eğitimler ve yeni beceriler
                </span>

            </div>

        </div>

        <div class="feature-item">

            <div class="feature-icon">

                <svg viewBox="0 0 24 24">
                    <path d="M12 3 5 6v5c0 4.6 2.7 8.7 7 10 4.3-1.3 7-5.4 7-10V6l-7-3Z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                </svg>

            </div>

            <div>

                <strong>
                    Güvenli ve Güvenilir
                </strong>

                <span>
                    Verileriniz her zaman güvende
                </span>

            </div>

        </div>

    </section>

</main>